export const ROW_MIN_HEIGHT_COMPACT = 32
export const ROW_MIN_HEIGHT_MEDIUM = 64
export const ROW_MIN_HEIGHT_TALL = 128
export const ROW_HEADER_HEIGHT = 50

export const ROW_MODE_COMPACT = 'COMPACT'
export const ROW_MODE_MEDIUM = 'MEDIUM'
export const ROW_MODE_TALL = 'TALL'

export const ROW_HEIGHTS_BY_MODE = {
  [ROW_MODE_COMPACT]: ROW_MIN_HEIGHT_COMPACT,
  [ROW_MODE_MEDIUM]: ROW_MIN_HEIGHT_MEDIUM,
  [ROW_MODE_TALL]: ROW_MIN_HEIGHT_TALL,
}

export const SELECTION_LIMIT_MSG =
  '1,000 rows is the maximum amount available to edit. Please deselect or edit the current selection before editing more.'
